import {ReloadButton,} from '@flexinet/ui-components';
import {Box,} from '@mantine/core';
import {useParams} from 'react-router-dom';
import {useQueryClient} from '@tanstack/react-query';

export const ReloadRecordsButton = () => {
    const {id: invoiceId} = useParams();
    const queryClient = useQueryClient();

    if (typeof invoiceId === 'undefined') {
        throw new Error('invoiceId is required parameter')
    }

    const handleReload = () => {
        queryClient.invalidateQueries({ queryKey: ['invoice-items', invoiceId] });
    };

    return (
        <Box mx='s'>
            <ReloadButton onClick={handleReload}/>
        </Box>
    );
};
